import {
  OnboardingActions,
  OnboardingStatuses,
  paths,
  useMerchantQry,
  useOnboardingActionQry
} from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useHistory } from 'react-router-dom'
import { usePayApplicationFee } from './usePayApplicationFee'

export const useOnboardingAction = () => {
  const history = useHistory()

  const { merchant } = useMerchantQry()
  const { onboardingAction } = useOnboardingActionQry()
  const { payApplicationFee } = usePayApplicationFee()

  const getOnboardingStatusText = () => {
    switch (onboardingAction) {
      case OnboardingActions.NONE:
        return merchant.onboardingStatus === OnboardingStatuses.REJECTED_FINAL
          ? tr(
              'FRONTEND.BANKING.COMMON.ACCOUNT_REJECTED',
              'Please contact Customer Service to get support on your account verification.'
            )
          : null // 'APPROVED', 'INELIGIBLE':

      case OnboardingActions.NOT_STARTED:
      case OnboardingActions.ONBOARDING:
      case OnboardingActions.DOCUMENTS:
      case OnboardingActions.QUESTIONNAIRE:
      case OnboardingActions.APPLICATION_FEE:
        return tr(
          'FRONTEND.BANKING.ONBOARDING.COMPLETE_TO_ACCESS_FEATURES',
          'Complete your account Verify to get access to all features and increased payment limits.'
        )

      case OnboardingActions.UNDER_REVIEW:
        return tr('FRONTEND.BANKING.COMMON.ACCOUNT_UNDER_REVIEW', 'Your account verification is under review.')
    }
  }

  const startOrContinueOnboarding = () => {
    switch (onboardingAction) {
      case OnboardingActions.NOT_STARTED:
        history.push(paths.onboarding.selectType())
        break

      case OnboardingActions.ONBOARDING:
        history.push(paths.onboarding.continueOnboarding())
        break

      case OnboardingActions.DOCUMENTS:
        history.push(paths.onboarding.documents())
        break

      case OnboardingActions.QUESTIONNAIRE:
        history.push(paths.onboarding.questionnaireKyb())
        break

      case OnboardingActions.APPLICATION_FEE:
        payApplicationFee()
        break
    }
  }

  return { onboardingAction, startOrContinueOnboarding, getOnboardingStatusText }
}
